import gql from 'graphql-tag';

import DAILY_COMPACT_FRAGMENT from './DAILY_COMPACT_FRAGMENT';

export const GET_SERVICE_RUNS_DAILY_COMPACT = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String,
		$sortDirection: Int,
		$filter: ServiceRunPageFilter
	) {
		getServiceRuns(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...serviceRunDailyCompact
			}
			count
		}
	}
	${DAILY_COMPACT_FRAGMENT}
`;

export default GET_SERVICE_RUNS_DAILY_COMPACT;
